import { render, staticRenderFns } from "./ElementEditForm.vue?vue&type=template&id=efa65adc&scoped=true&"
import script from "./ElementEditForm.vue?vue&type=script&lang=js&"
export * from "./ElementEditForm.vue?vue&type=script&lang=js&"
import style0 from "./ElementEditForm.vue?vue&type=style&index=0&id=efa65adc&lang=scss&"
import style1 from "./ElementEditForm.vue?vue&type=style&index=1&id=efa65adc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa65adc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efa65adc')) {
      api.createRecord('efa65adc', component.options)
    } else {
      api.reload('efa65adc', component.options)
    }
    module.hot.accept("./ElementEditForm.vue?vue&type=template&id=efa65adc&scoped=true&", function () {
      api.rerender('efa65adc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/contents/survey-paper-manage/ElementEditForm.vue"
export default component.exports